import { render, staticRenderFns } from "./UnidentifiedStockTracking.vue?vue&type=template&id=3efa3953"
import script from "./UnidentifiedStockTracking.vue?vue&type=script&lang=js"
export * from "./UnidentifiedStockTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports